import { t } from 'i18next';

import React, { useRef } from 'react';

import { Icon } from '@thinkific/chalk/react-icons';

import ActionButton from '../../ActionButton';

interface AttachmentInputProps {
  accept: string;
  ariaControls: string;
  icon: Icon;
  multiple?: boolean;
  onFileSelected: (files: File[]) => void;
  onBtnClicked: () => void;
  label?: string;
}

const AttachmentInput = ({
  accept,
  ariaControls,
  icon,
  multiple = false,
  onFileSelected,
  onBtnClicked,
  label,
}: AttachmentInputProps) => {
  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    const files = Array.from(event.target.files || []);

    // clear the input value, so that the same file can be uploaded again
    if (inputRef.current) {
      inputRef.current.value = '';
    }

    if (files) {
      onFileSelected(files);
    }
  };

  const inputRef = useRef<HTMLInputElement>(null);

  return (
    <>
      <ActionButton
        arialLabel={label || t('Attachment', 'Attachment')}
        dataQa="attachment-file-picker__button"
        disabled={false}
        icon={icon}
        isActive={false}
        onClick={() => {
          if (inputRef.current) {
            inputRef.current.click();
          }
          onBtnClicked();
        }}
      />
      <input
        accept={accept}
        aria-controls={ariaControls}
        data-qa="attachment-file-picker__input"
        multiple={multiple}
        ref={inputRef}
        style={{ display: 'none' }}
        type="file"
        onChange={handleFileChange}
      />
    </>
  );
};

export default AttachmentInput;
